// extracted by mini-css-extract-plugin
module.exports = {"gtins":"styles_gtins__29dwz"};